export default __webpack_public_path__ + "static/media/B2B - Hero.a1474ae2.png";